module.exports = "pegasus_template/assets/blocks/column-14-theme5.png";